import TinyColor2 from 'tinycolor2';

export default (rawColor) => {
    const color = rawColor?.getBrightness ? rawColor : new TinyColor2(rawColor);

    return color.getBrightness() >= 220 || color.getAlpha() < 0.35;
};
